import ambulo  from './settings/ambulo'
import support from './settings/support'

const settings =
{
    ambulo,
    support
};

export default settings ;